import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import colorPalette from './styles/colorPalette';

const { primary, secondary, tertiary, quaternary, quinary } = colorPalette;

// Pulse animation for loading bar
const pulse = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

// Shimmer effect for loading bar
const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

const LoadingBarContainer = styled.div`
  width: 700px;
  height: 80px;
  background: linear-gradient(
    to right, 
    ${primary} 0%, 
    ${secondary} 50%, 
    ${primary} 60%
  );
  background-size: 200px 50px;
  background-repeat: no-repeat;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  animation: ${pulse} 1.5s infinite linear, 
             ${shimmer} 2s infinite linear;
`;

const LoadingText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${quaternary};
  font-weight: bold;
  font-size: 22px;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
`;

const LoadingProgressBar = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 10px;
  background: linear-gradient(
    to right, 
    transparent, 
    ${secondary}, 
    transparent
  );
  animation: ${pulse} 1s infinite alternate;
`;

function LoadingBar() {
  const gameLoadingPhrases = [
    "Generating a Fun Game For You...",
    "Crafting AI Magic...",
    "Achieving Self Awareness...",
    "Coding It Right Away...",
    "Brewing Game Excitement..."
  ];

  const [currentPhrase, setCurrentPhrase] = useState(gameLoadingPhrases[0]);

  // Cycle through phrases every 2 seconds
  React.useEffect(() => {
    const phraseInterval = setInterval(() => {
      const randomPhrase = gameLoadingPhrases[
        Math.floor(Math.random() * gameLoadingPhrases.length)
      ];
      setCurrentPhrase(randomPhrase);
    }, 2000);

    return () => clearInterval(phraseInterval);
  }, []);

  return (
    <LoadingBarContainer>
      <LoadingText>{currentPhrase}</LoadingText>
      <LoadingProgressBar />
    </LoadingBarContainer>
  );
}

export default LoadingBar;